import Vue from "vue";
import configDirective from "../directive/config-directive";
import initService from "./init-service";
import sessionIdDirective from "../directive/sessionId-directive";

let imsiPrefixes = String(configDirective.getIMSIPrefixes());
if (imsiPrefixes) imsiPrefixes = imsiPrefixes.split(",");
else imsiPrefixes = [];
console.log("imsiPrefixes", imsiPrefixes);
let headers = {
	headers: {
		"Content-Type": "application/json",
		"x-api-key": process.env.VUE_APP_CONFIG_APIKEY,
	},
};

let baseurl = `${process.env.VUE_APP_CONFIG_BASEURL}?method=IOT_OverwatchAPI&remote_call=`;
let userName = initService.getUserNameInfo();
let customer = initService.getCustomerInfo();
let group = initService.getGroupInfo();
let pId = sessionIdDirective.getJSessionId();


const overwatchService = {

	overWatchCommonAPI(param) {
		let defaultUrl = "https://api.dccllc.net/overwatch?method=";
		let url = `${defaultUrl}${param}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
		return Vue.axios.get(url, headers);
	},

	getStandardType() {
		let param = "GetStandard";
		return this.overWatchCommonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getType() {
		let param = "GetOpcodes";
		return this.overWatchCommonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getOverwatchSearch(formData) {
		let {fromDate, toDate, imsi, tId, rowLimit, order, standard, type} = formData;
		let param = `GetGridData&fromdate=${fromDate}&todate=${toDate}&imsi=${imsi}&tid=${tId}&rowlimit=${rowLimit}&orderby=${order}&standard=${standard}&opcodes=${type}&imsi_prefixes=${imsiPrefixes}&_search=false&nd=1633810935922&rows=-1&page=1&sidx=&sord=asc`;
		return this.overWatchCommonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getLatestDate() {
		let param = "GetLatestDate";
		return this.overWatchCommonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getOverwatchDetails(fileId, frameNum, standardId) {
		let param = `GetDetails&file_id=${fileId}&frame_num=${frameNum}&standard_id=${standardId}`;
		return this.overWatchCommonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getDownloadDetails(pcapFileId, standardId) {
		let param = `GetDownload&file=${pcapFileId}&standard=${standardId}`;
		return this.overWatchCommonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	getRelatedDataDetails(pcapFileId, frameNum, standardId, relatedTitle) {
		let param = `${relatedTitle}&file_id=${pcapFileId}&frame_num=${frameNum}&standard_id=${standardId}`;
		return this.overWatchCommonAPI(param)
			.then(response => response.data.message)
			.catch(error => console.error(error));
	},

	//https://stackoverflow.com/questions/53772331/vue-html-js-how-to-download-a-file-to-browser-using-the-download-tag
	downloadItem(url, label) {
		return Vue.axios.get(url, {responseType: "blob", headers: {Authorization: ""}}) //remove authorization header
			.then(response => {
				const blob = new Blob([response.data], {type: "application/text"});
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = label;
				link.click();
				URL.revokeObjectURL(link.href);
			}).catch(error => {
				console.error(error);
				return error;
			});
	},

};

export default overwatchService;
